import React from "react";
import TonelagExplorerMongoLazy from "./TonelagExplorerMongoLazy";

export default function TonelagPageLazy() {
  return (
    <TonelagExplorerMongoLazy
      datasetId="bokmaalets-tonelagspar"
      summaryPageSize={500}
      scanImageBasePath="/book_tonelag"
      persistReviews
    />
  );
}
